'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(ctx, next) {
        var req, externals, widgetId, _externals$methodName, methodName, host;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        req = ctx.req;

                        if (req.type === 'mbox') {
                            externals = ctx.req.externals;
                            widgetId = externals.widgetId, _externals$methodName = externals.methodName, methodName = _externals$methodName === undefined ? 'execute' : _externals$methodName;
                            host = process.env['NODE_ENV'] === 'production' ? 'widget.1688.com' : 'widget-test.1688.com';


                            ctx.req.url = '//' + host + '/front/getJsonComponent.json';
                            ctx.req.data = _extends({}, ctx.req.data, {
                                widgetId: widgetId,
                                namespace: widgetId,
                                methodName: methodName
                            });
                            // 将请求类型修改为 jsonp
                            ctx.req.type = 'jsonp';
                        }

                        _context.next = 4;
                        return next();

                    case 4:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    function mboxFetcher(_x, _x2) {
        return _ref.apply(this, arguments);
    }

    return mboxFetcher;
}();